import { DateHelper } from 'src/app/shared/helpers/date-helper';

/**
 * 批號效期判斷共用純函式。
 * 供庫別批號 目前/每日/每月 列表共用。
 */

/** 取得該筆的效期預警天數 (資料列自帶優先，否則用系統預設) */
export function getBatchAlertDays(itemAlertDays: number | null | undefined, systemAlertDays: number): number {
  return itemAlertDays != null ? itemAlertDays : systemAlertDays;
}

/** 有效日期已過期 (< 今天) */
export function isBatchExpired(expirationDate: Date | string | null | undefined, today: Date): boolean {
  if (!expirationDate) { return false; }
  return new Date(expirationDate) < today;
}

/** 有效日期接近到期 (今天 ≤ 效期 ≤ 今天 + 預警天數) */
export function isBatchNearExpiry(expirationDate: Date | string | null | undefined, alertDays: number, today: Date): boolean {
  if (!expirationDate) { return false; }
  const exp = new Date(expirationDate);
  const alertLine = DateHelper.addDay(today, alertDays);
  return exp >= today && exp <= alertLine;
}
